exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-title {\n  height: 48px;\n  font-size: 16px;\n  line-height: 1.5;\n  text-align: center;\n  color: rgba(0, 0, 0, 0.38); }\n\n.modal-section-title {\n  font-size: 16px;\n  font-weight: 500;\n  text-align: left;\n  color: #000000; }\n\n.modal-footer {\n  margin: 0 auto; }\n\n.clickable {\n  color: #757575; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/verify-code-sent-modal/verify-code-sent-modal.component.scss
// module id = ../../../../../src/app/shared/components/verify-code-sent-modal/verify-code-sent-modal.component.scss
// module chunks = main